/* eslint-disable */
import Vue from 'vue';
import axios from '@/utils/request'
// axios.defaults.crossDomain = true
// axios.defaults.withCredentials = true // 前端设置是否带cookie
console.log('process', process.env.NODE_ENV)

// 跨域接口才需要写apiHead
let apiHead
if (process.env.NODE_ENV === 'production') {
  apiHead = 'https://api.gongfuhaoche.com'
} else {
  apiHead = 'https://api-test.gongfuhaoche.com'
}
export function getFinances (auto_model_id) {
  return axios.get(`${apiHead}/v1/auto_model/${auto_model_id}/finances/`)
}
export function getInfo (auto_model_id) {
  return axios.get(`${apiHead}/v1/auto_model/${auto_model_id}/info/`)
}
/* 产品方案 */
// LDAP账号登录
export function doLogin (params) {
  return axios.post(`${apiHead}/api-token-auth/`, params)
}
// 模糊搜索车型信息
export function getCarInfo (keyword) {
  return axios.get(`${apiHead}/v1/auto_model/series/search/?search=${keyword}`)
}
// 提交产品方案
export function postProject (params, auto_model_id) {
  return axios.post(`${apiHead}/v1/auto_model/finances/?auto_model_id=${auto_model_id}`, params)
}
/* 信用评估 */
export function creditQualification (params) {
  return axios.post(`${apiHead}/v1/account/credits/`, params)
}
/* 获取活动列表 */
export function getActivities () {
  return axios.get(`${apiHead}/v1/auto_model/activities/`)
}

/* 主动还款 */
// 获取验证码
export function getValidCode (account) {
  return axios.get(`${apiHead}/v1/firmware/valid_code/?account=${account}`)
}
// 客户端登录
export function doClogin (params) {
  return axios.post(`${apiHead}/v1/account/login/`, params)
}
export function bankCardGetList (params) {
  return axios.get(`/auto-business-api/bankCard/getList`, {params})
}
export function bankCardPayRepayment (params) {
  return Vue.$_other_post(`/auto-business-api/bankCardPay/repayment`, params)
}
export function getUserProtocolStatus (params) {
  return axios.get('/auto-business-api/bankCard/getUserProtocolStatus', {params})
}
/*********************  C-TOKEN  ********************/
// 获取订单列表
export function getAutoOrder (params) {
  return axios.get(`/auto-business-api/order/getOrderList`, {params: params})
}
// 获取账单列表
export function getAccountList (params) {
  return axios.get(`/auto-business-api/order/getOrderDetail`, {params: params})
}
// 获取支付签名paySign
export function weixinParams(params) {
  return Vue.$_other_post(`/auto-business-api/weixinPay/repayment`, params)
}
// 取消支付回调
export function cancelPay(params) {
  return Vue.$_other_post(`/auto-business-api/weixinPay/cancel`, params)
}
/*********************  活动  ********************/

// 通用活动二维码获取接口 （国庆活动，双十一活动, 双十二活动）
export function getActivityCode (params) {
  return axios.get('/auto-business-sms/api/activity/getActivityCode', {params})
}
// 通用活动登录获取验证码接口 （金秋活动，国庆活动, 双十一活动, 双十二活动）
export function getActivityCaptcha (params) {
  return axios.get(`/auto-business-sms/captcha/freeLogin/sendCaptcha`, {params})
}
// h5支付和微信支付-获取支付参数接口（金秋活动, 双十一活动, 双十二活动）
export function webPay (params) {
  return Vue.$_other_post('/auto-business-sms/weixinPay/activityPay', params)
}
// h5Pay-查询支付结果（金秋活动, 双十一活动, 双十二活动）
export function searchResult (params) {
  return Vue.$_other_post('/auto-business-sms/weixinPay/payQuery', params)
}


// 销售分享-发送验证码
export function getsaleShareValidCode (mobile, businessType = 'ZNQCaptcha') {
  return axios.get(`/auto-business-sms/captcha/freeLogin/sendCaptcha?mobile=${mobile}&businessType=${businessType}`)
}
// 销售分享-奖品
export function getrewardZNQPrize ({mobile, captcha, cmm}) {
  return axios.get(`/auto-business-sms/api/activity/rewardZNQPrize?mobile=${mobile}&captcha=${captcha}&businessType=ZNQCaptcha&cmm=${cmm}`)
}
// 生成二维码（销售分享，金秋活动）
export function getZNQQrCode (access_token) {
  return axios.get(`/auto-business-sms/api/activity/getZNQQrCode?access_token=${access_token}`)
}
// 金秋活动验证码登录-点1元秒杀
export function autumnActivityLogin (params) {
  return axios.get(`/auto-business-sms/api/activity/autumnActivityLogin`, {params})
}
// 国庆活动-验证码登录
export function gqActivityLogin (params) {
  return axios.get(`/auto-business-sms/api/activity/gqActivityLogin`, {params})
}
// 国庆活动-点击抽奖
export function getGQLottery (params) {
  return axios.get('/auto-business-sms/api/activity/getGQLottery', {params})
}
// 国庆活动-获取用户抽奖信息
export function getUserLotteryInfo(params) {
  return axios.get('/auto-business-sms/api/activity/getUserLotteryInfo', {params})
}
// 2021中秋国庆活动-获取用户抽奖信息
export function getLuckyBoyList(params) {
  return axios.get('/auto-business-sms/api/activity/getLuckyBoyList', {params})
}
// 2021中秋国庆活动-验证码登录
export function autumn2021ActivityLogin (params) {
  return Vue.$_other_post(`/auto-business-sms/api/activity/autumn2021ActivityLogin`, params)
}
// 2021中秋活动抽奖
export function luckyDrawAutumn2021 (params) {
  return Vue.$_other_post('/auto-business-sms/api/activity/luckyDrawAutumn2021', params)
}
// 双十一活动-用户验证码登录
export function shuang11Login (params) {
  return Vue.$_other_post(`/auto-business-sms/api/activity/shuang11Login`, params)
}
// 获取双11商品列表数据
export function getShuang11CarList (params) {
  return axios.get(`/auto-business-sms/api/activity/getShuang11PrizeList`, {params})
}
// 双11抢购接口
export function shuang11Buy (params) {
  return axios.get(`/auto-business-sms/api/activity/shuang11Buy`, {params})
}
// 查询双11订单信息
export function getShuang11Order (params) {
  return axios.get(`/auto-business-sms/api/activity/getShuang11Order`, {params})
}
// 双11取消支付
export function Shuang11CancelPay (params) {
  return Vue.$_other_post(`/auto-business-sms/api/activity/cancelActivityOrder`, params)
}
// 双十二活动-用户登录
export function shuang12Login (params) {
  return Vue.$_other_post(`/auto-business-sms/api/activity/shuang12Login`, params)
}
// 领取双12首付减免券
export function rewardShuang12Coupon (params) {
  return Vue.$_other_post(`/auto-business-sms/api/activity/rewardShuang12Coupon`, params)
}
// 领取双12油卡
export function rewardShuang12OilCard (params) {
  return Vue.$_other_post(`/auto-business-sms/api/activity/rewardShuang12OilCard`, params)
}
// 618活动领取奖励
export function activity618RewardPrize (params) {
  return Vue.$_other_post(`/auto-business-sms/api/activity/activity618RewardPrize`, params)
}

/*********************  功夫好车app  ********************/
// 保险分期支付 用户服务协议
export function getInsuranceContractPreview(params) {
  return axios.get('/auto-business-api/renewal/getContractPreview', {params})
}

